

export function getMgpsApiHelperParams(isAdmin: boolean, storage:any)
{
    const environment = isAdmin && storage?.environment === "prod" ? process.env.REACT_APP_MPGS_ENV : process.env.REACT_APP_MPGS_TEST_ENV;
    const merchant = isAdmin && storage?.environment === "prod" ? process.env.REACT_APP_PROD_MID : process.env.REACT_APP_TEST_MID;
    const path = isAdmin && storage?.environment === "prod" ? "prod" : "test";
    return {environment, merchant, path};
}